/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Allrightsreservedby3Inputs */



/**
* | output |
* | --- |
* | "All rights reserved by" |
*
* @param {Allrightsreservedby3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const allrightsreservedby3 = /** @type {((inputs?: Allrightsreservedby3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Allrightsreservedby3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("All rights reserved by")
	return /** @type {LocalizedString} */ ("Alle Rechte vorbehalten von")
});
export { allrightsreservedby3 as "allRightsReservedBy" }